// Chakra imports
import { Box, Flex, Text, Select, useColorModeValue } from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card.js";
import PieChart from "components/charts/PieChart";
import { pieChartOptions } from "variables/charts";
import { fetchData } from "variables/charts";
import { VSeparator } from "components/separator/Separator";
// import React from "react";
import React, { useState, useEffect } from 'react';

export default function Conversion(props) {
  const { ...rest } = props;

  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const cardColor = useColorModeValue("white", "navy.700");
  const cardShadow = useColorModeValue(
    "0px 18px 40px rgba(112, 144, 176, 0.12)",
    "unset"
  );

  const [project, setProject] = useState('BRC'); // new state variable for the time period
  const [pieChartData, setChartData] = useState([]); // Initialize with existing data
  const [percentageData, setPercentageData] = useState({});

  useEffect(() => {
    const fetchDataAndUpdateState = async () => {
      try {
        const newData = await fetchData(project);
        setChartData(newData);

        const total = newData.reduce((acc, val) => acc + val, 0);
        const percentages = newData.map((val) => (val / total) * 100);

        const labels = ['HM', 'only_S', 'S+F', 'only_F', 'Other'];
        let mappedData = {};

        labels.forEach((label, index) => {
          mappedData[label] = Math.round(percentages[index]);
        });


        setPercentageData(mappedData); // Update the mapped data state
      } catch (error) {
        console.error('An error occurred while fetching data:', error);
        // Optionally set some state to indicate that an error occurred
        // setErrorState(true);
      }
    };

    fetchDataAndUpdateState();

    // Optionally: Set up any additional logic here to re-fetch the data at intervals
    // or in response to some event.

  }, [project]);

  const DataCard = ({ bg, textColor, label, value }) => (
    <Flex direction='row' py='5px' me='10px'>
      <Flex align='center'>
        <Box h='4px' w='4px' bg={bg} borderRadius='50%' me='4px' />
        <Text fontSize='xs' color='secondaryGray.600' fontWeight='700' mb='5px'>
          {label}
        </Text>
      </Flex>
      <VSeparator mx={{ base: "3px", xl: "3px", "2xl": "3px" }} />
      <Text fontSize='lg' color={textColor} fontWeight='700'>
        {value != null ? value : 'Loading...'}%
      </Text>
    </Flex>
  );

  const YourCardComponent = ({ percentageData, cardColor, textColor }) => (
    <Card bg={cardColor} flexDirection='column' boxShadow={cardShadow} w='30%' p='15px' px='20px' mt='15px' mx='auto'>
      <DataCard bg='#008000' textColor={textColor} label='HM' value={percentageData['HM']} />
      <DataCard bg='#800080' textColor={textColor} label='only_S' value={percentageData['only_S']} />
      <DataCard bg='#FFA500' textColor={textColor} label='S+F' value={percentageData['S+F']} />
      <DataCard bg='#FF0000' textColor={textColor} label='only_F' value={percentageData['only_F']} />
      <DataCard bg='#D3D3D3' textColor={textColor} label='Other' value={percentageData['Other']} />
    </Card>
  );


  // console.log(percentageData)
  return (
    <Card p='20px' align='center' direction='column' w='100%' {...rest}>
      <Flex
        px={{ base: "0px", "2xl": "10px" }}
        justifyContent='space-between'
        alignItems='center'
        w='100%'
        mb='8px'
      >
        <Text color={textColor} fontSize='md' fontWeight='600' mt='4px'>
          Glycan type compositions
        </Text>
        <Flex direction='row' alignItems='center'> {/* Changed direction to 'row' */}
          <label htmlFor='tumorTypes' style={{ fontWeight: 'bold', marginRight: '10px' }}>Select</label> {/* Added marginRight for spacing */}
          <Select
            id='tumorTypes'
            fontSize='sm'
            variant='subtle'
            defaultValue='BRC'
            width='unset'
            fontWeight='700'
            onChange={(e) => setProject(e.target.value)} // Update state when option changes
          >
            <option value='BRC'>BRC</option>
            <option value='CCRCC'>CCRCC</option>
            <option value='CRC'>CRC</option>
            <option value='GBM'>GBM</option>
            <option value='HNSCC'>HNSCC</option>
            <option value='LSCC'>LSCC</option>
            <option value='LUAD'>LUAD</option>
            <option value='OV'>OV</option>
            <option value='PDAC'>PDAC</option>
            <option value='UCEC'>UCEC</option>
          </Select>
        </Flex>
      </Flex>


      <Flex direction='row' py='5px' me='10px'>
        <PieChart

          h='100%'
          w='100%'
          chartData={pieChartData}
          chartOptions={pieChartOptions}
        />
        <YourCardComponent

          percentageData={percentageData}
          cardColor={cardColor}
          textColor={textColor}
        />
      </Flex>
    </Card>
  );
}
